import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useIconPickerStyles = makeStyles({
  container: {
    ...shorthands.padding("8px"),
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  searchContainer: {
    marginBottom: "8px",
  },
  searchInput: {
    width: "100%",
  },
  tabsContainer: {
    display: "flex",
    overflowX: "auto",
    marginBottom: "8px",
    boxSizing: "border-box",
    position: "sticky",
    top: "0",
    backgroundColor: tokens.colorNeutralBackground1,
    zIndex: 10,
    paddingBottom: "4px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(90px,1fr))",
    gap: "4px",
    flex: 1,
    overflowY: "auto",
    alignContent: "start",
  },
  iconButton: {
    position: "relative",
    cursor: "pointer",
    backgroundColor: "transparent",
    ...shorthands.border("2px", "solid", "transparent"),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    ...shorthands.padding("2px"),
  },
  iconButtonSelected: {
    ...shorthands.border("2px", "solid", "#23415a"),
    backgroundColor: "#e3f2fd",
  },
  iconButtonDisabled: {
    cursor: "default",
  },
  iconImage: {
    display: "block",
    width: "88px",
    height: "88px",
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
  },
  selectionBadge: {
    position: "absolute",
    top: "4px",
    right: "4px",
    minWidth: "20px",
    height: "20px",
    fontSize: tokens.fontSizeBase100,
  },
  footer: {
    marginTop: "8px",
    ...shorthands.padding("8px", "0", "15px"),
    ...shorthands.borderTop("1px", "solid", tokens.colorNeutralStroke2),
    backgroundColor: tokens.colorNeutralBackground1,
  },
  insertButton: {
    width: "100%",
  },
});
